import { call } from '@advanza/api'
import phoneClicksSchema from 'schemes/phoneClicksSchema'
import { _changeFilter, _fetchItems } from './lists'

export const PHONECLICKS_REQUEST = 'PHONECLICKS_REQUEST'
export const PHONECLICKS_RECEIVE_LIST = 'PHONECLICKS_RECEIVE_LIST'
export const PHONECLICKS_CHANGE_FILTER = 'PHONECLICKS_CHANGE_FILTER'

export function fetchList(filterId) {
    return _fetchItems(filterId, {
        url: 'office/phone-clicks/get-list',
        schema: phoneClicksSchema,
        requestActionName: PHONECLICKS_REQUEST,
        receiveActionName: PHONECLICKS_RECEIVE_LIST,
        reducerKey: 'phoneClicks',
    })
}

export function changePhoneClicksFilter(filterId, options) {
    return _changeFilter(filterId, options, {
        reducerKey: 'phoneClicks',
        fetchFunc: fetchList,
        actionType: PHONECLICKS_CHANGE_FILTER,
    })
}

export function reclaimPhoneClick(phoneClickId, date) {
    return function (dispatch, getState) {
        const phoneClick = getState().phoneClicks.entities.phoneClicks[phoneClickId]
        if (phoneClick.reclaimed) {
            return Promise.resolve()
        }
        return call(`office/reclaims/reclaim-manually/${phoneClickId}/phone`, {
            method: 'post',
            json: { date },
        }).then((response) => {
            dispatch({ type: 'INVALIDATE_PHONECLICKS' })
            return Promise.resolve()
        })
    }
}
